/**
 * Shared so the trigger mutation invalidates the exact key useAgenticRun reads. Invalidation matches
 * by prefix, so a key that disagrees by even one trailing segment silently matches nothing, leaving
 * the poll unstarted while a run is already under way.
 *
 * `dataSource` is part of every key so flipping the Sample data toggle swaps cache entries instead of
 * refetching over a fixture, and so a real run cannot overwrite the fixture the page is rendering.
 * It is spelled out here rather than imported as AgenticRunDataSource, which would point this shared
 * module at a feature one; both callers pass that type, so widening it there fails here.
 *
 * `viewedRun.byId` exists only for an explicitly-selected, non-latest run. When nothing is selected,
 * `useViewedRun` reuses `latestRun.detail` verbatim (same key, same cache entry, same poll) rather
 * than declaring its own "viewing latest" key — the two hooks would otherwise poll the identical
 * `.../runs/latest` endpoint independently, doubling the request and the 5s timer for the common case.
 */
export const agenticInsightsQueryKeys = {
  latestRun: {
    detail: (dataSource: 'real' | 'mock', loopId: number) =>
      ['loop-agentic-insights', 'run', 'latest', dataSource, loopId] as const,
  },
  viewedRun: {
    byId: (dataSource: 'real' | 'mock', loopId: number, runId: string) =>
      ['loop-agentic-insights', 'run', 'viewed', dataSource, loopId, runId] as const,
  },
  list: {
    detail: (dataSource: 'real' | 'mock', loopId: number) =>
      ['loop-agentic-insights', 'run', 'list', dataSource, loopId] as const,
  },
};
